<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>
  <!-- FILTROS -->
  <app-filters filtros
    [name]="'filtros.per' | translate"
    [array]="periodos"
    [typeFilter]="Filters.PERIOD"
    (eventClick)="cambioPeriodo($event)">
  </app-filters>  
   <!-- CONTENIDO -->
  <div contenido class="zonaContenido">
    <div class="zonaSup">
      <div class="izquierda">
        <div class="headers w3-titulo-contenidomenuSC"> <!-- barra titulo-->
          <div class="w3-half"> <!--titulo tabla-->
            <span class="w3-margin-left-contenido">{{'riesgo-credito.reservas.titZona1'| translate }}</span>
            <span class="w3-margin-left-contenido">&bull;</span>
            <span class="w3-margin-left-filter w3-subtitulo">{{periodoSeleccionado?.periodo}}</span>
          </div>
          <!-- <div class="w3-rest w3-right "> 
            <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            [matMenuTriggerFor]="menuTabla">
              more_vert
            </mat-icon>
            <mat-menu #menuTabla="matMenu">
              <button class="mat-menu-item w3-caja-menu" mat-menu-item>
                <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
                <span>{{'menu.Exportar' | translate}}</span>
              </button>
              
            </mat-menu>
          </div> -->
        </div>
        <div class="w3-row w3-scroll tabla">
          @if(dataResumen.length > 0){
            <table class="w3-table borderInf">
              <thead>
                <tr class="w3-table-title alinCenter" style="line-height: 1.5;">
                  <td class="w3-table-titleLow stikyColumCon w3-border-right-balance marginsH"></td>
                  <td class="w3-table-titleLow stikyColumCon w3-border-right-balance marginsH">{{'riesgo-credito.reservas.titTabla1'| translate }}</td>
                  <td class="w3-table-titleLow stikyColumCon w3-border-right-balance marginsH">{{'riesgo-credito.reservas.titTabla2'| translate }}</td>
                  <td class="w3-table-titleLow stikyColumCon w3-border-right-balance marginsH">{{'riesgo-credito.reservas.titTabla3'| translate }}</td>
                </tr>
                
              </thead>
              <tbody>
                @for(data of dataResumen; track data; let i = $index){
                  <tr class="w3-table-trtd borderInfLow">
                    <td class="alinLeft borderAllLow marginsH">{{data.descripcion}}</td>
                    @if(i<5){
                      <td class="alinRight borderAllLow marginsH">{{data.rcapital | formaterNumber:0:miles:decimal}} @if(i==4){%}</td>                    
                      <td class="alinRight borderAllLow marginsH">{{data.rIntereses | formaterNumber:0:miles:decimal}} @if(i==4){%}</td>
                      <td class="alinRight borderAllLow marginsH">{{data.capInte | formaterNumber:0:miles:decimal}} @if(i==4){%}</td>
                    }@else {
                      <td class="alinRight borderAllLow marginsH" colspan="3">{{data.rcapital | formaterNumber:2:miles:decimal}}</td>
                    }
                    
                  </tr>
                }
              </tbody>
            </table>
          }@else{<app-skeleton-table [filas]="7" [columnas]="4"/>}
        </div>
      </div>
      <div class="derecha">
        <div class="headers w3-titulo-contenidomenuSC"> <!-- barra titulo-->
          <div class="w3-half" style="width: 80%;"> <!--titulo tabla-->
            <span class="w3-margin-left-contenido">{{'riesgo-credito.reservas.titZona2'| translate }}</span>
            <span class="w3-margin-left-contenido">&bull;</span>
            <span class="w3-margin-left-filter w3-subtitulo">{{periodoSeleccionado?.periodo}}</span>
          </div>
          <div class="w3-rest w3-right "> <!--menu tabla-->
            <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            [matMenuTriggerFor]="menuTabla">
              more_vert
            </mat-icon>
            <mat-menu #menuTabla="matMenu">
              <button class="mat-menu-item w3-caja-menu" mat-menu-item>
                <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
                <span>{{'menu.Exportar' | translate}}</span>
              </button>
            </mat-menu>
          </div>
        </div>
        @if(dataIndice.length > 0){
          @for(t of dataIndice; track t; let i = $index){
            @if(i < 2){
              <app-tarjetas 
                [header]="t.descripcion | translate"
                [value]="t.dato"
                [siceHeader]="'1rem'"
                [siceValue]="'1.3rem'"
                [footer]="''"
                [icon]="''"
                [alto]="'10vh'"
              />    
            }@else{
              <app-tarjetas 
                [header]="t.descripcion | translate"
                [valueStr]="t.dato +' %'"
                [siceHeader]="'1rem'"
                [siceValue]="'1.3rem'"
                [footer]="''"
                [icon]="''"
                [alto]="'10vh'"
              />  
            }            
          }          
        }@else {
          <app-skeleton-card/>
          <app-skeleton-card/>
          <app-skeleton-card/>
        }
      </div>
    </div>
    <div class="zonaInf ">
      <div class="headers w3-titulo-contenidomenuSC"> <!-- barra titulo-->
        <div class="w3-half"> <!--titulo tabla-->
          <span class="w3-margin-left-contenido">{{perspectivaSelec?.nombre}}</span>
          <span class="w3-margin-left-contenido">&bull;</span>
          <span class="w3-margin-left-filter w3-subtitulo">{{periodoSeleccionado?.periodo}}</span>
        </div>
        <div class="w3-rest w3-right "> <!--menu tabla-->
          <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
          [matMenuTriggerFor]="menuTabla2">
            more_vert
          </mat-icon>
          <mat-menu #menuTabla2="matMenu">
            <div mat-menu-item [matMenuTriggerFor]="mperspectivas">
              <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">account_tree</mat-icon>
              {{'menu.Perspectivas'|translate}}
            </div>
            <button class="mat-menu-item w3-caja-menu" mat-menu-item>
              <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
              <span>{{'menu.Exportar' | translate}}</span>
            </button>
          </mat-menu>
          <mat-menu #mperspectivas="matMenu">
            @for(p of perspectivas; track $index){
              <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="cambiarPerspectiva(p)">
                <span>{{p.nombre}}</span>
              </button>
            }
          </mat-menu>
        </div>
      </div>
      <div class="w3-row w3-scroll tabla">
        @if(dataTabla.length > 0){
          <table class="w3-table borderInf">
            <thead>
              <tr class="w3-table-title alinCenter">
                <td class="w3-table-titleLow stikyColumCon w3-border-right-balance marginsH" style="line-height: 1.2;">{{'riesgo-credito.reservas.titTabla4'| translate }}</td>
                <td class="w3-table-titleLow stikyColumCon w3-border-right-balance marginsH" style="line-height: 1.2;">{{'riesgo-credito.reservas.titTabla5'| translate }}</td>
                <td class="w3-table-titleLow stikyColumCon w3-border-right-balance marginsH" style="line-height: 1.2;">{{'riesgo-credito.reservas.titTabla6'| translate }}</td>
                <td class="w3-table-titleLow stikyColumCon w3-border-right-balance marginsH" style="line-height: 1.2;">{{'riesgo-credito.reservas.titTabla7'| translate }}</td>
                @if(perspectivaSelec.id !== 1){
                  <td class="w3-table-titleLow stikyColumCon w3-border-right-balance marginsH" style="line-height: 1.2;">{{'riesgo-credito.reservas.titTabla7.1'| translate }}</td>
                }
                <td class="w3-table-titleLow stikyColumCon w3-border-right-balance marginsH" style="line-height: 1.2;">{{'riesgo-credito.reservas.titTabla8'| translate }}</td>
                <td class="w3-table-titleLow stikyColumCon w3-border-right-balance marginsH" style="line-height: 1.2;">{{'riesgo-credito.reservas.titTabla9'| translate }}</td>
                <td class="w3-table-titleLow stikyColumCon w3-border-right-balance marginsH" style="line-height: 1.2;">{{'riesgo-credito.reservas.titTabla10'| translate }}</td>
                <td class="w3-table-titleLow stikyColumCon w3-border-right-balance marginsH" style="line-height: 1.2;">{{'riesgo-credito.reservas.titTabla11'| translate }}</td>
                <td class="w3-table-titleLow stikyColumCon w3-border-right-balance marginsH" style="line-height: 1.2;">{{'riesgo-credito.reservas.titTabla12'| translate }}</td>
                <td class="w3-table-titleLow stikyColumCon w3-border-right-balance marginsH" style="line-height: 1.2;">{{'riesgo-credito.reservas.titTabla13'| translate }}</td>
              </tr>
            </thead>
            <tbody>
              @for (d of dataTabla; track $index) {
                <tr class="w3-table-trtd borderInfLow">
                  <td class="alinCenter borderAllLow marginsH" [style.background-color]="d.color">{{d.categoria}}</td>
                  <td class="alinLeft borderAllLow marginsH">{{d.nombre}}</td>
                  <td class="alinCenter borderAllLow marginsH">{{d.dMora}}</td>
                  <td class="alinCenter borderAllLow marginsH">{{d.nPrestamos | formaterNumber:0:miles:decimal}}</td>
                  @if(perspectivaSelec.id !== 1){
                    <td class="alinCenter borderAllLow marginsH">{{d.provisiones | formaterNumber:0:miles:decimal}} %</td>
                  }
                  <td class="alinCenter borderAllLow marginsH">{{d.sCapital | formaterNumber:0:miles:decimal}}</td>
                  <td class="alinCenter borderAllLow marginsH">{{d.sDesprotegido | formaterNumber:0:miles:decimal}}</td>
                  <td class="alinCenter borderAllLow marginsH">{{d.sInteres | formaterNumber:0:miles:decimal}}</td>
                  <td class="alinCenter borderAllLow marginsH">{{d.consolidado | formaterNumber:0:miles:decimal}}</td>
                  <td class="alinCenter borderAllLow marginsH">{{d.rCapital | formaterNumber:0:miles:decimal}}</td>
                  <td class="alinCenter borderAllLow marginsH">{{d.rInteres | formaterNumber:0:miles:decimal}}</td>
                </tr>
              }
            </tbody>
          </table>
        }@else{<app-skeleton-table [filas]="8" [columnas]="11"/>}        
      </div>
    </div>
  </div>
</app-esqueleto-tableros>